import { createFileRoute } from '@tanstack/react-router';
import { CarriersInvite } from '@uturn/portal/modules/carriers/pages/invite';

export const Route = createFileRoute('/_protected/carriers/add')({
	component: CarriersInvite,
});
